import { PricingState } from '../../../@types';

const initialState: PricingState = {};
export default initialState;
